// ============================================================
// Footer.js - Dark blue footer with 4 columns
// ============================================================

import React from "react";
import { FOOTER_QUICK_LINKS, FOOTER_SERVICES, CONTACT_INFO } from "../data";

function Footer() {
  return (
    <footer>
      <div className="footer-grid">

        {/* Column 1 - Brand Description */}
        <div>
          <div className="footer-logo">
            <img src="/logo.jpeg" alt="WHANI Logo" className="footer-logo-image" />
          </div>
          <p className="footer-desc">
            A multi-disciplinary organization providing comprehensive on-ground
            support services for infrastructure, logistics, safety, and community
            development in the Andaman & Nicobar Islands.
          </p>
        </div>

        {/* Column 2 - Quick Links */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            {FOOTER_QUICK_LINKS.map((link) => (
              <li key={link}>
                <a href={`#${link.toLowerCase().replace(/\s+/g, "-")}`}>
                  {link}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 3 - Services */}
        <div className="footer-col">
          <h4>Our Services</h4>
          <ul>
            {FOOTER_SERVICES.map((service) => (
              <li key={service}>
                <a href="#our-services">{service}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 4 - Contact Info */}
        <div className="footer-col">
          <h4>Contact Us</h4>
          <div className="footer-contact">
            <div className="contact-item">
              <span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              </span>
              <span>{CONTACT_INFO.address}</span>
            </div>
            <div className="contact-item">
              <span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
              </span>
              <div>
                {CONTACT_INFO.phones.map((phone) => (
                  <div key={phone}>{phone}</div>
                ))}
              </div>
            </div>
            <div className="contact-item">
              <span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
              </span>
              <span>{CONTACT_INFO.email}</span>
            </div>
            <a
              href={CONTACT_INFO.whatsapp}
              target="_blank"
              rel="noreferrer"
              className="btn-whatsapp-footer"
            >
              💬 WhatsApp Us
            </a>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <span>© 2026 WHANI. All rights reserved.</span>
        <div className="footer-values">
          {["Integrity", "Safety", "Professionalism", "Responsibility"].map((v, i) => (
            <span key={v}>{i !== 0 && " • "}{v}</span>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
